<template>
  <div>
    <el-input readonly v-model="myValue" placeholder="富文本信息">
      <el-button slot="append" @click="dialog.show=true" size="small" type="primary" icon="el-icon-edit"></el-button>
    </el-input>
    <el-dialog title="" :visible.sync="dialog.show" fullscreen>
      <my-edit v-model="myValue" v-if="dialog.show"></my-edit>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      myValue: this.value,
      dialog: { show: false },
    };
  },

  watch: {
    value(newValue) {
      this.myValue = newValue
    },
    myValue(newValue) {
      this.$emit('input', newValue)
    }
  },
}
</script>
